<template>
  <section class="state">
      <img src="@/assets/murray.png" alt="Murray">
      <h1>You are awesome!</h1>
      <h3>Make sure your friends are awesome too!</h3>
  </section>
</template>

<script>
export default {
    name: 'Status-3',
    computed: {
        student() {
            return this.$store.getters.student;
        }
    }
}
</script>

<style lang="scss">

  .state {

    img {
      max-width: 180px;
      width: 100%;
    }
    
    > h1, h3 {
      text-align: center;
    }
  }

</style>